import { render, staticRenderFns } from "./doctorsSharing.vue?vue&type=template&id=59823ef7&scoped=true&"
import script from "./doctorsSharing.vue?vue&type=script&lang=js&"
export * from "./doctorsSharing.vue?vue&type=script&lang=js&"
import style0 from "./doctorsSharing.vue?vue&type=style&index=0&id=59823ef7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59823ef7",
  null
  
)

export default component.exports